import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule, Injectable, Optional, Inject, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { BlockUIModule } from 'primeng/blockui';
// import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Global } from './Global';
import { MessageModule } from 'primeng/message';
import { MenubarModule } from 'primeng/menubar';
import { AppComponent } from './app.component';
import { DataService, UIBlockingStatus } from './common/data.service';
import { AuthGuardService } from './common/auth-guard.service';
import { AppTokenHandler, HTTPStatus } from './common/app-token-handler';
import { ErrorHandler } from '@angular/core';
import { AppErrorHandler } from './common/app-error-handler';
import { HttpClientModule, HTTP_INTERCEPTORS,HttpClientJsonpModule,HttpInterceptor } from '@angular/common/http';
import { WinAuthInterceptor } from './common/interceptor';

import { HomeComponent } from '../app/inside-of-application/home/home.component';
import { DashboardComponent } from './inside-of-application/dashboard/dashboard.component';
import { ListComponent } from '../app/inside-of-application/list/list.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { AlertComponent } from './out-of-application/alert/alert.component';
import { ProgressComponent } from './out-of-application/progress/progress.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { LocationMasterComponent } from './inside-of-application/Admin/LocationMaster/location-master/location-master.component';
import { LocationMasterViewComponent } from './inside-of-application/Admin/LocationMaster/location-master-view/location-master-view.component';
import { DropdownModule } from 'primeng/dropdown';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateAdapter as LocalDate } from '@angular/material/core';
import { AuditTrailComponent } from './out-of-application/audit-trail/audit-trail.component';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { CharachterDirective } from './Directive/CharOnly';
import { NumberDirective } from './Directive/NumbersOnly';
import { DecimalDirective } from './Directive/DecimalOnly';
import { AlphanumericDirective } from './Directive/AlphaNumeric';
import { MatExpansionModule } from '@angular/material/expansion';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FlatpickrModule } from 'angularx-flatpickr';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { CommonModule} from '@angular/common';
import { FileUploadComponent } from './out-of-application/file-upload/file-upload.component';
import { StartupPopupComponent } from './out-of-application/startup-popup/startup-popup.component';
import { FooterComponent } from './inside-of-application/footer/footer.component';
import {CreateRecoveryComponent} from './inside-of-application/Admin/create-recovery/create-recovery.component';

import { CreateRecoveryViewComponent } from './inside-of-application/Admin/create-recovery-view/create-recovery-view.component';
import { BulkUploadComponent } from './inside-of-application/Admin/bulk-upload/bulk-upload.component';
import {WaveOFFComponent} from './inside-of-application/Admin/wave-off/wave-off.component';
import { GenerateJournalVoucherComponent } from './inside-of-application/generate-journal-voucher/generate-journal-voucher.component';
import { TwoDigitDecimaNumberDirective } from './two-digit-decima-number.directive';
import { FinanceRecoveryViewComponent } from './inside-of-application/finance-recovery-view/finance-recovery-view.component';
import {NgbPaginationModule, NgbAlertModule,NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import {AppInsightsService} from './common/app-insights.service';
import { PreventSpecialCharsDirective } from './Directive/prevent-special-chars.directive';
import { Idle } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'DD/MM/YYYY', monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Injectable()
export class MomentUtcDateAdapter extends MomentDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
        // const dialogRef = this._dialog.open(StartupPopupComponent, {
        //     width: '950px',
        //     disableClose: true
        // });
    }

    createDate(year: number, month: number, date: number): Moment {
        // Moment.js will create an invalid date if any of the components are out of bounds, but we
        // explicitly check each case so we can throw more descriptive errors.
        if (month < 0 || month > 11) {
            throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
        }

        if (date < 1) {
            throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
        }

        const result = moment.utc({ year, month, date }).locale(this.locale);

        // If the result isn't valid, the date must have been out of bounds for this month.
        if (!result.isValid()) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }

        return result;
    }
}

@NgModule({
    declarations: [
        AppComponent,
        LocationMasterComponent,
        HomeComponent,
         DashboardComponent,
          ListComponent,
           BadRequestComponent,
        PageNotFoundComponent,
         LogoutComponent, 
         UnAuthorizeComponent,
          SessionExpiredComponent,
        LoginComponent,
         DummyLoginComponent,
          AlertComponent, 
          ProgressComponent,
        LocationMasterComponent,
        LocationMasterViewComponent,
        AuditTrailComponent,
        CharachterDirective,
        DecimalDirective,
        NumberDirective,
        AlphanumericDirective,
        FileUploadComponent,
        StartupPopupComponent,
        FooterComponent,
        CreateRecoveryComponent,
        CreateRecoveryViewComponent,
        BulkUploadComponent,
        WaveOFFComponent,
        GenerateJournalVoucherComponent, 
        TwoDigitDecimaNumberDirective,
        FinanceRecoveryViewComponent,
        PreventSpecialCharsDirective
    ],
    imports: [ BrowserModule,CommonModule, BrowserAnimationsModule, ReactiveFormsModule, AppRoutingModule,
        HttpClientModule, HttpClientJsonpModule, ToastModule, MessageModule, MenubarModule, BlockUIModule, MatDialogModule,
        MatProgressSpinnerModule, MatTableModule, FormsModule, AutoCompleteModule, MatTabsModule, MatCardModule,
        MatInputModule, MatIconModule, MatRadioModule, MatButtonModule, MatPaginatorModule, MatSortModule,
        MatDialogModule, MatTooltipModule, DropdownModule, MatDatepickerModule, MatNativeDateModule, MatExpansionModule,
        MatCheckboxModule,NgbModule,NgbModalModule, FlatpickrModule.forRoot(),NgbPaginationModule
        , NgIdleKeepaliveModule.forRoot(),NgbAlertModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        // NgxSpinnerModule
        // Ng4LoadingSpinnerModule.forRoot()
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })

    ],
    providers: [
        DataService, AppTokenHandler, HTTPStatus, AuthGuardService, UIBlockingStatus, MessageService, 
        Global, AppErrorHandler,CookieService,AppInsightsService,
        { provide: HTTP_INTERCEPTORS, useClass: WinAuthInterceptor, multi: true },
        // { provide: HTTP_INTERCEPTORS, useClass: WinAuthInterceptor, multi: true, useValue: '/' },

        { provide: ErrorHandler, useClass: AppErrorHandler },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LocalDate, useClass: MomentUtcDateAdapter }
        
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule {
}






